/**
 * The contract detail's binding of the shared detail-page surface.
 *
 * Everything structural - the shell, the drag, the rail, the persistence - lives
 * in `shared/surface`. This file is the whole of what contracts add: its config
 * (`./layout`) and one typed hook over the generic one. Contracts have no detail
 * pane or reader, so `useSurfaceWithoutSelection` is the right entry point.
 */

import {
  useSurfaceWithoutSelection,
  UseDetailSurfaceOptions,
  UseSurfaceWithoutSelectionResult,
} from '../../shared/surface/useDetailSurface';
import { CONTRACT_SURFACE, CONTRACT_TABS, ContractPanelId, ContractTab } from './layout';

export { CONTRACT_SURFACE, CONTRACT_TABS };
export type { ContractPanelId, ContractTab };

export type ContractWorkspace = UseSurfaceWithoutSelectionResult<
  ContractPanelId,
  never,
  ContractTab
>;

export const useContractWorkspace = (
  contractUuid: string,
  options: Omit<UseDetailSurfaceOptions<ContractTab>, 'entityId'> = {},
): ContractWorkspace =>
  useSurfaceWithoutSelection<ContractPanelId, never, ContractTab>(
    CONTRACT_SURFACE,
    { ...options, entityId: contractUuid },
  );
